const translations = {
  fr: {
    metrics: {
      apply: 'Appliquer',
      listeningTimePageTitle: 'Temps d\'écoute',
      reachPageTitle: 'Portée',
      compare: 'Comparer',
      notCompare: 'Ne plus comparer',
      totalReach: 'Portée moy. hebdomadaire',
      cumulativeReach: 'Portée cumulative',
      comparedTo: 'Comparé à',
      hours: 'Heures',
      minutes: 'Minutes',
      interval: 'Intervalle',
      from: 'De',
      to: 'À',
      missingSampling: 'Les données affichées comportent une plus grande marge d\'erreur dû à un manque d\'échantillonnage pour la période demandée.',
      referenceDate: 'Date de référence',
      comparisonDate: 'Date de comparaison',
      cancelComparison: 'Annuler la comparaison',
      placeholderText: 'Cliquez sur le bouton "Appliquer" pour exécuter une requête',
    },
  },
  en: {
    metrics: {
      apply: 'Apply',
      listeningTimePageTitle: 'Listening time',
      reachPageTitle: 'Reach',
      compare: 'Compare',
      notCompare: 'Stop comparison',
      totalReach: 'Average Weekly Reach',
      cumulativeReach: 'Cumulative Reach',
      comparedTo: 'Compared to',
      hours: 'Hours',
      minutes: 'Minutes',
      interval: 'Interval',
      from: 'From',
      to: 'To',
      missingSampling: 'Displayed data may contain a larger margin of error from a lack of sampling in the given period.',
      referenceDate: 'Reference date',
      comparisonDate: 'Comparison date',
      cancelComparison: 'Cancel comparison',
      placeholderText: 'Click the "Apply" button to execute a query',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/i18n/metrics.js